import React, { memo, useCallback } from "react";
import { Box, Checkbox, Tooltip, Typography } from "@mui/material";
import ActivityBadge from "./ActivityBadge";

const isChapterOrEpisode = (type) =>
  ["Capítulo/Episódio", "Episódio"].includes(type);

const VersionRow = memo(
  ({
    item,
    index,
    versionIndex,
    onCheckBoxClick,
    formatDate,
    convertDatePtBr,
  }) => {
    const typeName = item.attachmentType?.name;
    const isChEp = isChapterOrEpisode(typeName);

    const handleCheckBoxClick = useCallback(
      () => onCheckBoxClick(item, index, versionIndex),
      [onCheckBoxClick, item, index, versionIndex]
    );

    return (
      <Box component="div" className="versionItem">
        <Box component="li" className="type" onClick={handleCheckBoxClick}>
          <Checkbox
            checked={!!item.isActive}
            size="small"
            sx={{
              mr: "8px",
              color: "#c0c3f8",
              "&.Mui-checked": { color: "#17b4e1" },
            }}
          />
          <Box component="span" className="typeName">
            {!!typeName && typeName}
            {` ${isChEp ? item.chapterNumber : ""}`}
          </Box>
          {isChEp && item.blockNumber > 0 && (
            <Box component="span" className="blockNumber">
              Bloco {item.blockNumber}
            </Box>
          )}
        </Box>

        <Box component="li" className="version">
          {typeName !== "Adendo" && (
            <>
              <Box component="span" className="versionNumber">
                {item.version}ª
              </Box>
              <Box component="span" className="versionText">
                versão
              </Box>
            </>
          )}
        </Box>

        <Box component="li" className="file">
          {item.fileName}
        </Box>

        <Box component="li" className="receivedAt">
          {formatDate(convertDatePtBr(item.receivedAt))}
        </Box>

        <Box component="li" className="activitiesNumber">
          <Tooltip
            title={
              <Typography variant="body2" sx={{ fontFamily: "Globotipo Text" }}>
                Total de atividades criadas: {item.activityCount ?? 0}
              </Typography>
            }
            arrow
            placement="top"
          >
            <Box component="span">
              <ActivityBadge activityCount={item.activityCount} />
            </Box>
          </Tooltip>
        </Box>
      </Box>
    );
  }
);

export default VersionRow;
